import React from 'react';
import { Box } from '@mui/material';

// Scales with the manual form or chat preview container.
const QRCODE_SIZE = 400;

export default function FluidQrcode({ code }) {
  return (
    <Box
      borderRadius="4px"
      mb={1}
      style={{ border: '1px solid #ddd' }}
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <img
        src={`/api/barcodes/qrcode?code=${encodeURIComponent(code)}&width=${QRCODE_SIZE}&height=${QRCODE_SIZE}`}
        alt="qrcode"
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    </Box>
  );
}
